<template>
  <gat-compact-field v-if="ImoNumber" :value="ImoNumber" hide="phone" label="Vessel details">
    <a
      class="gridLink text-truncate mr-2"
      :href="`https://www.vesseltracker.com/en/Ships/${ImoNumber}.html`"
      target="_blank">
      More info <v-icon small class="gridLink ml-1">mdi-open-in-new</v-icon>
    </a>
  </gat-compact-field>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ShowVesselTrackerInfo',
  props: {
    ImoNumber: String,
  },
  components: {},

  data() {
    return {};
  },

  computed: {},

  created() {},

  watch: {},

  methods: {},
});
</script>

<style scoped></style>
